(function () {
  function initMarquee() {
    document.querySelectorAll('.logos').forEach(function (logos) {
      var slide = logos.querySelector('.logosSlide');
      if (!slide) return;

      // Remove previous clone if re-running on resize
      var existing = logos.querySelectorAll('.logosSlide');
      if (existing.length > 1) {
        existing[1].remove();
      }

      // Only animate when logos overflow the parent container
      var container = logos.parentElement;
      if (slide.scrollWidth > container.clientWidth) {
        var clone = slide.cloneNode(true);
        logos.appendChild(clone);
        logos.setAttribute('data-overflow', 'true');
      } else {
        logos.removeAttribute('data-overflow');
      }
    });
  }

  initMarquee();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMarquee, 200);
  });
})();
